export default "__VITE_ASSET__C7IN5AR4__"